import { FaSortDown } from "react-icons/fa";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React from "react";
import SectionTitle from "../../../components/layout/SectionTitle";
import { AGENDA_MORETOKNOW_SECTION } from "../../../util/constants";
import { classes, StyledSectionWrapper } from "./styles";

const AgendaMoreToKnow = () => {
  return (
    <StyledSectionWrapper sectionId={AGENDA_MORETOKNOW_SECTION}>
      <Container className={classes.container}>
        <SectionTitle text="Mais aussi..." variant="innoGrey" />
        <div>
          <Accordion className={classes.accordion} square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<FaSortDown className={classes.expandIcon} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Assistance téléphonique</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                L'abonnement à Innovance Agenda inclut l'accès illimité à notre
                assistance téléphonique 5 jours sur 7.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.accordion} square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<FaSortDown className={classes.expandIcon} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Maintenance évolutive</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Vous bénéficiez régulièrement de mises à jour qui intègrent des
                correctifs, des évolutions ou l'ajout de nouvelles
                fonctionnalités.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.accordion} square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<FaSortDown className={classes.expandIcon} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Remontez le temps</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Vous adopter Innovance Agenda en cours d’exercice ? Vous pouvez
                rattraper les temps déjà passés grâce à l’outil de saisie rapide
                ou en prenant contact avec notre assistance téléphonique.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.accordion} square={true} elevation={0}>
            <AccordionSummary
              expandIcon={<FaSortDown className={classes.expandIcon} />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>Accès bonus</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Un accès gratuit à un agenda inclus pour 10 membres du Bureau de
                l’association, 10 bénévoles ou pour des ressources matérielles
                de l’association (véhicules, salles de formation,
                vidéoprojecteurs…).
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </Container>
    </StyledSectionWrapper>
  );
};

export default AgendaMoreToKnow;
